import { useEffect, useRef } from 'react';

const useApiPolling = (
  fetchData,
  enabled = true,
  dependency = [],
  paginated = false,
  pollingInterval = 1 * 60 * 1000, // 1 minute
  skipInitialFetch = false
) => {
  const pollingRef = useRef(null);
  const prevDependencyStringRef = useRef(JSON.stringify(dependency));
  const isInitializedRef = useRef(false);
  const hasSkippedInitialFetchRef = useRef(false);

  const fetchResponse = () => {
    if (paginated) {
      fetchData(1);
    } else {
      fetchData();
    }
  };

  useEffect(() => {
    const currentDependencyString = JSON.stringify(dependency);

    if (prevDependencyStringRef.current !== currentDependencyString) {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
      isInitializedRef.current = false;
      prevDependencyStringRef.current = currentDependencyString;
    }

    if (enabled && !isInitializedRef.current) {
      if (!(skipInitialFetch && !hasSkippedInitialFetchRef.current)) {
        fetchResponse();
      } else {
        hasSkippedInitialFetchRef.current = true;
      }
      isInitializedRef.current = true;
    }

    if (enabled && !pollingRef.current) {
      pollingRef.current = setInterval(fetchResponse, pollingInterval);
    } else if (!enabled && pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  }, [enabled, pollingInterval, JSON.stringify(dependency)]);
};

export default useApiPolling;
